
import {debounceTime} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Configuration } from '../../../app.constants';
import { Message } from '@angular/compiler/src/i18n/i18n_ast';
import * as moment from 'moment'
import { NotificationService } from '../../../shared/services/notification.service';

@Injectable()
export class WorkgroupService {
  public notify = {
    associateId: '',
    message: '',
    type: '',
    actionUrl: ''
  }


  constructor(
    private router: Router,
    private _http: HttpClient,
    private config:Configuration,
    private notificationService:NotificationService,

  ) { }

  public createWorkGroup(workgroup: any){
    console.log(workgroup);
    if (workgroup != null) {
      return this._http.post(`${this.config.ServerApiUrl}/WorkingGroup/create`,workgroup);
     }
}

  public getWorkGroup(id?: any):Promise<any>{
    return new Promise(resolve=>{
        this._http.post(`${this.config.ServerApiUrl}/WorkingGroup/read`,{ids:id}).subscribe(res=> {
          resolve(res)});
    });
  }

  public getWorkGroupPaging(index: any,size:any):Promise<any>{
    return new Promise(resolve=>{
        this._http.get(`${this.config.ServerApiUrl}/WorkingGroup/readAll/${index*size}/${size}`).pipe(debounceTime(500)).subscribe(res=> {
          resolve(res);
        });
    });
  }

  public updateWorkGroup(group: any):Promise<any>{
    return new Promise(resolve=>{
      if (group) {
        this._http.put(`${this.config.ServerApiUrl}/WorkingGroup/update`,group).subscribe(res=> {
          resolve(res)
        },(error)=>{
        });
      }
      else 
        resolve('Empty Object');  
    });
  }

  public getWorkGroupFiltered(search: any,pagesize:any,pageindex:any,startDate:any,endDate:any,groupStatus:any, sort:any ,approval?:any,privacy?:any) {
    var body={
      startdate: startDate ? startDate : '',
      enddate: endDate ? endDate : '',
      approval:approval,
      regex:search,
      skip:pageindex*pagesize,
      limit:pagesize,
      privacy:privacy,
      sort: sort,
      status:(groupStatus.active === groupStatus.inactive ? ['Inactive','Active']: groupStatus.active? 'Active':'Inactive')
    }

    // if(startDate){
    //   body.startdate=startDate
    // }
    // if(endDate)
    //   body.enddate=endDate;
    return this._http.post(`${this.config.ServerApiUrl}/WorkingGroup/readAllReg`,body).pipe(debounceTime(500));
  }

  public sendMail(member:any,group:any,option:any):Promise<any>{
    return new Promise(resolve=>{
      if(option==-1){
        // removed
        var mail={
          email: member.email,
          subject: 'Workgroup',
          message:
          `Dear ${member.fullName},
              ${group.lastEditedBy[0].name} removed you from a workgroup:
              Workgroup Name:${group.groupAlias}
              Description:${group.description}`
        }
        this.removeFromNotification(member.associateId, group.groupAlias, group._id);
      }else if(option==0){
        // added
        var mail={
          email: member.email,
          subject: 'Workgroup',
          message:
          `Dear ${member.fullName},
              You have been added to a workgroup:
              Name:${group.groupAlias}
              Description:${group.description}
              Role:${member.role}
              URL:  http://sonepartalent.com:3001/home/working-group/profile/${group._id}`
              //http://sonepartalent.com:3001/home/working-group/profile/
        }
        this.addToNotification(member.associateId,member.role,group.groupAlias,group.lastValidatedBy.name, group._id);
        // this.sendNotification(member.associateId,`You have been added to a workgroup <span class='fw-bold d-inline'>${group.groupAlias}</span>.`);
      }else if(option==1){
        // rejected
        var mail={
          email: member.email,
          subject: 'Workgroup',
          message:
          `Dear ${member.fullName},
              Your work group has been disapproved by ${group.lastValidatedBy.name}:
              Reason: ${group.hrComments}
              URL:  http://sonepartalent.com:3001/home/working-group/profile/${group._id}`
              //http://sonepartalent.com:3001/home/working-group/profile/
        }
        this.workgroupDisapprovedNotification(member.associateId, group.groupAlias, group.lastValidatedBy.name, group._id);
      }else if(option==2){
        // approved
        var mail={
          email: member.email,
          subject: 'Workgroup',
          message:
          `Dear ${member.fullName},
              Your work group has been approved by ${group.lastValidatedBy.name}:
              Reason: ${group.hrComments}
              URL:  http://sonepartalent.com:3001/home/working-group/profile/${group._id}`
              //http://sonepartalent.com:3001/home/working-group/profile/
        }
          this.workgroupApprovalNotification(member.associateId,group.groupAlias,group.privacySetting, group._id);
        // this.sendNotification(member.associateId,`Your workgroup <span class='fw-bold d-inline'>${group.groupAlias}</span> has been approved by <span class='fw-bold d-inline'>${group.lastValidatedBy.name}</span>.`);
      }
      this._http.post(`${this.config.ServerApiUrl}/sendEmail`,mail).subscribe(res=> {
        resolve(res)});        
    });
  }

  sendNotification(associateId:any,message:any,groupId){
    this.notify.associateId=associateId;
    this.notify.message=message;
    this.notify.type='Workgroup';
    this.notify.actionUrl = `/home/working-group/profile/${groupId}`;
    if(this.notify.associateId)
      this._http.post(`${this.config.ServerApiUrl}/notification/create`,this.notify).subscribe(noti=>{});
  }

  sendValidationAction(action: any) {
    this._http.post(`${this.config.ServerApiUrl}/actionCenter/create`, action).subscribe(noti => { });
  }

  public getWorkGroupsByName(searchText: string) {
    return this._http.post(`${this.config.ServerApiUrl}/WorkingGroup/search`, {'search': searchText});
  }

  addToNotification(associateID,role,groupName,userName,groupId){
    const msg=`You're now a <span class='fw-bold d-inline'>${role}</span> in the <span class='fw-bold d-inline'>${groupName}</span>, assigned by <span class='fw-bold d-inline'>${userName}</span>`;
    this.notificationService.sendNotification(associateID,msg,'Workgroup',`/home/working-group/profile/${groupId}`)  }
  
    roleChangeNotification(associateID,oldRole,newRole,groupName,userName,groupId){
    const msg=`Your role as <span class='fw-bold d-inline'>${oldRole}</span> was changed to <span class='fw-bold d-inline'>${newRole}</span> for <span class='fw-bold d-inline'>${groupName}</span>, as updated by <a class='fw-bold d-inline'>${userName}</a>`;
    this.notificationService.sendNotification(associateID,msg,'Workgroup',`/home/working-group/profile/${groupId}`)
  }
  
  workgroupApprovalNotification(associateID,groupName,privacy,groupId){
    const msg=`Your Workgroup <span class='fw-bold d-inline'>${groupName}</span> is now approved for <span class='fw-bold d-inline'>${privacy}</span> view`;
    this.notificationService.sendNotification(associateID,msg,'Workgroup',`/home/working-group/profile/${groupId}`)
  }
  
  workgroupArchiveNotification(associateID,groupName,groupId){
    const msg=`Your access to <span class='fw-bold d-inline'>${groupName}</span> has ended as it has now been archived`;
    this.notificationService.sendNotification(associateID,msg,'Workgroup',`/home/working-group/profile/${groupId}`)
  }
  
  workgroupUpdateNotification(){

  }

  workgroupDisapprovedNotification(associateID,groupName, userName, groupId){
    const msg=`The requested <span class='fw-bold d-inline'>${groupName}</span> has been disapproved by <a class='fw-bold d-inline'>${userName}</a>`;
    this.notificationService.sendNotification(associateID,msg,'Workgroup',`/home/working-group/profile/${groupId}`)
  }
  
  removeFromNotification(associateID,groupName,groupId){
    const msg=`Your participation in <span class='fw-bold d-inline'>${groupName}</span> has ended as of <span class='fw-bold d-inline'>${moment().format('DD MMM YYYY').toString()}</span>`
    this.notificationService.sendNotification(associateID,msg,'Workgroup','home/associate/feed')
  }

}


